import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icon.d.ts').IconHamburger}
 */
const IconHamburger = () => {
    return (
        <svg
            aria-hidden='true'
            fill='none'
            height='32'
            stroke='currentColor'
            strokeWidth='1'
            viewBox='0 0 24 24'
            width='32'
            xmlns='http://www.w3.org/2000/svg'>
            <line
                x1='3'
                x2='21'
                y1='6'
                y2='6' />
            <line
                x1='3'
                x2='21'
                y1='12'
                y2='12' />
            <line
                x1='3'
                x2='21'
                y1='18'
                y2='18' />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default IconHamburger;
